import React from 'react';
import PropTypes from 'prop-types';
import { classNames } from 'utils';
import './loading.scss';

export default class Loading extends React.PureComponent {
  static propTypes = {
    when: PropTypes.bool,
    style: PropTypes.object,
    size: PropTypes.number,
    margin: PropTypes.number,
    children: PropTypes.node,
    className: PropTypes.string,
    progress: PropTypes.number,
    slow: PropTypes.bool,
  };

  render() {
    let { when = true, children, className, progress, slow } = this.props;

    if (when) {
      let { size, margin, style = {} } = this.props;

      // Note size should be undefined by default
      style.width = size;
      style.height = size;
      style.margin = margin;

      const stroke = size ? (1 / size) * 75 : 3;

      const isProgressing = typeof progress === 'number' && progress > 0;
      const progressingStyle = isProgressing
        ? {
            strokeDasharray: `${progress < 25 ? progress * 2 : 100}, ${
              progress < 25 ? 200 : 100 - progress
            }`,
          }
        : undefined;

      return (
        <div
          className={classNames('loading', className, {
            progressing: isProgressing,
            rotating: !isProgressing,
            slow,
          })}
          style={style}
        >
          <svg viewBox="25 25 50 50">
            {isProgressing && (
              <circle cx="50" cy="50" r="20" fill="none" strokeWidth={stroke} />
            )}
            <circle
              cx="50"
              cy="50"
              r="20"
              fill="none"
              strokeMiterlimit="10"
              strokeWidth={stroke}
              style={progressingStyle}
            />
          </svg>
          {children}
        </div>
      );
    }
    return <div>{children || null}</div>;
  }
}
